import React, { useState } from 'react';
import { Table, Input } from 'antd';
import Pagination from './Pagination';
import { Select, Button } from 'antd';
import { CSVLink } from 'react-csv';
import { useLocation } from 'react-router-dom';



const NewTransactionTable = ({ data, handleSearch,setSelectedLevel,selectedLevel, prepareDataForCSV, onSearch, columns, dataSource, page, onLevelChange, totalPages, size, setPage, setSize }) => {
  
    const location = useLocation();

    const handleChange = (value) => {
        setSelectedLevel(value);
        onLevelChange(value);
    };

    const filteredDataSource = selectedLevel ? dataSource.filter(item => item.Status === selectedLevel) : dataSource;


    const onChange = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
        setPage(pagination.current);
        setSize(pagination.size);
    };

    const onPageChange = (page) => {
        setPage(page);
    };

    const handlePageSizeChange = (size) => {
        setSize(size);
    };

    const uniqueLevelNames = [...new Set(data?.map(item => item.Status))];

    return (
        <>         
            <Table className='my-3' columns={columns} dataSource={filteredDataSource} onChange={onChange} pagination={false} />
            <Pagination
                totalPages={totalPages}
                currentPage={page}
                pageSize={size}
                onPageChange={onPageChange}
                onPageSizeChange={handlePageSizeChange}
            />
        </>
    );
};

export default NewTransactionTable;
